// extracted by mini-css-extract-plugin
export default {"cardHeader":"styles_cardHeader__ksyuN"};